import React, { useState } from 'react';

import { createDocument } from '../../firebase/firebase.utils';

import FormInput from '../../components/form-input/form-input.component';
import CustomButton from '../../components/custom-button/custom-button.component';
import Header from '../../components/header/header.component';
import './contact-form.styles.scss';
import { withFirebase } from '../../../Firebase';
import { withAuthorization } from '../../../Session';

const ContactForm = props => {
  const type = 'contact';

  const [contactsFormState, setContactsFormState] = useState({
    name: '',
    company: '',
    email: '',
    position: ''
  });

  const handleSubmit = async event => {
    event.preventDefault();

    const contactRef = await createDocument(contactsFormState, type,props.firebase);
    props.history.push(`/${type}/${contactRef}`);
  }

  const handleChange = event => {
    const { name, value } = event.target;
    setContactsFormState({
      ...contactsFormState,
      [name]: value
    })
  }

  return (
    <>
    <Header/>
    <div className='contact-form'>
      <h2>Add person</h2>
      <span>Proporciona información sobre el nuevo Lead</span>
      <form onSubmit={handleSubmit}>
        <FormInput 
          name='name'
          type='text'
          value={contactsFormState.name} 
          handleChange={handleChange} 
          required 
          label='Nombre' />
        <FormInput 
          name='company'
          type='company'
          value={contactsFormState.company} 
          handleChange={handleChange} 
          required 
          label='Compañía' />
        <FormInput 
          name='email'
          type='email'
          value={contactsFormState.email} 
          handleChange={handleChange} 
          required 
          label='Email' />
        <FormInput 
          name='position'
          type='position'
          value={contactsFormState.position} 
          handleChange={handleChange} 
          required 
          label='Posición' />
        <div className='buttons'>
          <CustomButton type='submit'> Añadir Lead </CustomButton>
        </div>
      </form>
    </div>
    </>
  );
}


const condition = authUser => !!authUser;
export default withFirebase(withAuthorization(condition)(ContactForm));
